import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=c54f12e2"
import script from "./ClipboardCopy.vue?vue&type=script&lang=js"
export * from "./ClipboardCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports